import store from "../store";
import { LOGOUT_SUCCESS, SIGN_IN, SIGN_UP } from "../actions";



export const SignIn = ({ email, password }) => {
    store.dispatch({
        type: SIGN_IN,
        payload: { email, password },
    })
}
export const SignUp = ({ email, password, password_confirmation }) => {
    store.dispatch({
        type: SIGN_UP,
        payload: { email, password, password_confirmation },
    })
}
